"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaMaxFeeAmountToJSON = exports.RosettaMaxFeeAmountFromJSONTyped = exports.RosettaMaxFeeAmountFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaMaxFeeAmountFromJSON(json) {
    return RosettaMaxFeeAmountFromJSONTyped(json, false);
}
exports.RosettaMaxFeeAmountFromJSON = RosettaMaxFeeAmountFromJSON;
function RosettaMaxFeeAmountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'currency': _1.RosettaCurrencyFromJSON(json['currency']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaMaxFeeAmountFromJSONTyped = RosettaMaxFeeAmountFromJSONTyped;
function RosettaMaxFeeAmountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'currency': _1.RosettaCurrencyToJSON(value.currency),
        'metadata': value.metadata,
    };
}
exports.RosettaMaxFeeAmountToJSON = RosettaMaxFeeAmountToJSON;
//# sourceMappingURL=RosettaMaxFeeAmount.js.map